import React from "react";
import {
  ArrowLeftIcon,
  ArrowRightIcon,
  IconWrapper,
} from "common/components/icon";
import { PaginationWrapper, PageButton, getPageNumbers } from "./ListStyles";

export const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const pageNumbers = getPageNumbers(currentPage, totalPages);

  if (pageNumbers.length <= 1) return null;

  return (
    <PaginationWrapper>
      {currentPage !== 1 && (
        <IconWrapper
          size={"1rem"}
          onClick={() => onPageChange(currentPage - 1)}>
          <ArrowLeftIcon />
        </IconWrapper>
      )}
      {pageNumbers.map((page, idx) =>
        page === "..." ? (
          <span key={`dot-${idx}`} style={{ padding: "0 0.25rem" }}>
            ⋯
          </span>
        ) : (
          <PageButton
            key={page}
            $active={page === currentPage}
            onClick={() => onPageChange(page)}>
            {page}
          </PageButton>
        ),
      )}
      {currentPage !== totalPages && (
        <IconWrapper
          size={"1rem"}
          onClick={() => onPageChange(currentPage + 1)}>
          <ArrowRightIcon />
        </IconWrapper>
      )}
    </PaginationWrapper>
  );
};
